import React, { useState } from 'react'
import { BrazilStates, CepMask } from 'core/constants'
import { Field } from 'core/components/form/field'
import { Select } from 'core/components/form/select'
import { TextInput } from 'core/components/form/text-input'
import { onlyNumbers } from 'core/helpers/format'
import { getAddress } from 'helpers'
import { Button } from 'core/components/button'

export const AddressForm = ({ form, onBlurNumber }) => {
  const [loading, setLoading] = useState(false)
  const { entity, errors, touched } = form

  return (
    <>
      <div className="row">
        <div className="col-lg-3">
          <Field label="CEP">
            <div className="input-group">
              <TextInput
                customClassName="form-control-xl"
                mask={CepMask}
                meta={{ error: errors.postalCode, touched: touched.postalCode }}
                onChange={(postalCode, type) =>
                  form.handleChange({
                    path: 'postalCode',
                    type,
                    values: prev => ({ ...prev, postalCode }),
                  })
                }
                value={entity.postalCode}
              />

              <div className="input-group-append">
                <Button
                  type="button"
                  className="btn btn-brand"
                  icon="fas fa-search"
                  loading={loading}
                  onClick={() => {
                    if (onlyNumbers(entity.postalCode).length === 8) {
                      setLoading(true)
                      getAddress(entity.postalCode)
                        .then(resp => {
                          if (!resp.erro) {
                            form.setValues({
                              city: resp.localidade,
                              streetName: resp.logradouro,
                              district: resp.bairro,
                              state: resp.uf,
                            })
                          }
                        })
                        .finally(() => setLoading(false))
                    }
                  }}
                />
              </div>
            </div>
          </Field>
        </div>

        <div className="col-lg">
          <Field label="Endereço">
            <TextInput
              customClassName="form-control-xl"
              meta={{ error: errors.streetName, touched: touched.streetName }}
              onChange={(streetName, type) => {
                form.handleChange({
                  path: 'streetName',
                  type,
                  values: prev => ({ ...prev, streetName }),
                })
              }}
              value={entity.streetName}
            />
          </Field>
        </div>

        <div className="col-lg-2">
          <Field label="Número">
            <TextInput
              customClassName="form-control-xl"
              meta={{ error: errors.streetNumber, touched: touched.streetNumber }}
              onChange={(streetNumber, type) => {
                form.handleChange({
                  path: 'streetNumber',
                  type,
                  values: prev => ({ ...prev, streetNumber }),
                })

                if (type === 'blur' && onBlurNumber) {
                  onBlurNumber()
                }
              }}
              value={entity.streetNumber}
            />
          </Field>
        </div>
      </div>

      <div className="row">
        <div className="col-lg">
          <Field label="Bairro">
            <TextInput
              customClassName="form-control-xl"
              meta={{ error: errors.district, touched: touched.district }}
              onChange={(district, type) =>
                form.handleChange({
                  path: 'district',
                  type,
                  values: prev => ({ ...prev, district }),
                })
              }
              value={entity.district}
            />
          </Field>
        </div>

        <div className="col-lg">
          <Field label="Cidade">
            <TextInput
              customClassName="form-control-xl"
              meta={{ error: errors.city, touched: touched.city }}
              onChange={(city, type) =>
                form.handleChange({
                  path: 'city',
                  type,
                  values: prev => ({ ...prev, city }),
                })
              }
              value={entity.city}
            />
          </Field>
        </div>

        <div className="col-lg-3">
          <Field className="field-xl" label="Estado">
            <Select
              getDisplay={({ name }) => name}
              getId={({ uf }) => uf}
              items={BrazilStates}
              meta={{ error: errors.state, touched: touched.state }}
              onChange={({ uf: state, timeZone }) =>
                form.handleChange({
                  path: 'state',
                  values: { state, timeZone },
                })
              }
              selected={entity.state}
            />
          </Field>
        </div>
      </div>
    </>
  )
}
